import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { api, fetcher, wrappedCollectionFetcher } from "services/api.service";
import { LabelColor } from "types/locationManagement/labelColor";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: LoaderFunctionArgs) => {
  const { locationTypeId } = params;
  const [locationType, labelColors] = await Promise.all([
    fetcher<LocationManagementLocationType>(`/location_management/location_types/${locationTypeId}`),
    wrappedCollectionFetcher<LabelColor>("/location_management/label_colors?page[size]=100"),
  ]);
  return { locationType, labelColors: labelColors.rows || [] };
});

export async function action({ params, request }: ActionFunctionArgs) {
  const fd = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "PUT",
      url: `/location_management/location_types/${params.locationTypeId}`,
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 200) {
    return redirect("/location-types");
  }
  return res;
}
